///include /assets/js/app/s/basket.js
///include /assets/js/app/p/user-contact-info.js
///include /assets/js/app/p/brand.js

"use strict"

class VueSidebar {
    init() {
        const app = Vue3.createApp({
            name: 'sidebar',
            data() {
                return {
                    basket: AnyBasket.inst,
                    brand: brand,
                    catalogue: UserCatalogue.inst,
                    preview: false,
                    /**
                     * @type {?GET.Stack.Catalogue.$ns.catalogue._design.product._view.byType.output}
                     */
                    customProductCategories: [],
                    productsAvailableByType: null,
                    productBoxes: {
                        package: {
                            link: {
                                // See mounted hook that may change this link
                                href: "/order-hosting",
                                label: translation.get("shop_view_plans"),
                            },
                            title: translation.get("shop_webhosting"),
                            icon: "far fa-cloud",
                            group: "group-package",
                        },
                        vps: {
                            link: {
                                href: "/order-vps",
                                label: translation.get("shop_view_plans"),
                            },
                            title: translation.get("shop_virtual_private_servers"),
                            icon: "far fa-server",
                            group: "group-vps",
                        },
                        domain: {
                            link: {
                                href: "/domain-search",
                                label: translation.get("shop_domain_search"),
                            },
                            title: translation.get("shop_domain_names"),
                            icon: "far fa-map-marker",
                            group: "group-domain",
                        },
                        cloud_server: {
                            link: {
                                href: "/build-server",
                                label: translation.get("group_cloud_server_add_title"),
                            },
                            title: translation.get("shop_cloud_servers"),
                            icon: "far fa-server",
                            group: "group-cloud-server",
                        },
                        custom: {
                            link: {
                                href: "/order-additional-services",
                                label: translation.get("shop_view"),
                            },
                            title: translation.get("shop_additional_products_services"),
                            icon: "far fa-plus-square",
                            group: "group-additional",
                        },
                        stack_user_package_allowance: {
                            link: {
                                href: "/order-allowance",
                                label: translation.get("shop_order_allowance"),
                            },
                            title: translation.get("shop_order_allowance_title"),
                            icon: "far fa-cloud",
                            group: "group-stack_user_package_allowance",
                        },
                        tls_certificate: {
                            link: {
                                href: "/order-ssl",
                                label: translation.get("shop_view_certificates"),
                            },
                            title: translation.get("shop_ssl_certificates"),
                            icon: "far fa-lock",
                            group: "group-tls_certificate",
                        },
                    },
                    store: AnyStore.inst,
                    settings: SharedSettings.inst,
                    /** @type {?boolean} */
                    state: null,
                    user: SUser.inst,
                    userContactInfo: UserContactInfo.inst,
                    store: AnyStore.inst,
                    get balance() {
                        return this.store.paymentItems?.find(i => i.type === "balance") ?? null;
                    },
                    get contact() {
                        return this.contactCache || this.settings.contact;
                    },
                    get contactCache() {
                        return this.userContactInfo.contact
                    },
                    get brand() {
                        // @ts-ignore
                        if(window.header && window.header.view) {
                            // @ts-ignore
                            return window.header.view.brand ? window.header.view.brand : null
                        }
                        return null
                    },
                    get isBalanceEnabled() {
                        if (this.paymentConfig) {
                            const balance = this.paymentConfig.paymentGateways.find(pg => pg.type === "balance" && pg.isEnabled === true);

                            return balance ? true : false;
                        } else {
                            return false;
                        }
                    },
                    get paymentConfig() {
                        return this.store.paymentConfig;
                    },
                    get products() {
                        if(this.catalogue.products) {
                            //@ts-ignore
                            return this.catalogue.products.filter(
                                p => p instanceof SBBalanceProduct && p.forSale
                            )
                        } else {
                            return []
                        }
                    },
                    get availableBalance() {
                        return this.balance && this.balance.availableBalance ? this.balance.availableBalance.toFixed(2) : 0.00;
                    }
                };
            },
            async mounted() {
                this.store.paymentConfig && await this.store.preloadSingle("paymentConfig");
                this.user.identityInfo && await this.user.preloadSingle("identityInfo");
                this.store.paymentItems && await this.store.preloadSingle("paymentItems");

                this.getBrandLogo();

                function showHideTooltips(){
                    if (document.querySelector('#sidenav-cdn') || document.querySelector('#sidenav-email') || document.querySelector('#sidenav-laravel') || document.querySelector('#sidenav-security-sidebar') || document.querySelector('#sidenav-domain-names') || document.querySelector('#sidenav-webtools')){
                        $('.sidebar-container ul li a').tooltip().tooltip('enable');
                        $('.sidebar-container ul div').tooltip().tooltip('enable');
                        document.querySelector('.sidebar-container').classList.add('collapsed');
                    } else {
                        $('.sidebar-container ul li a').tooltip().tooltip('disable');
                        $('.sidebar-container ul div').tooltip().tooltip('disable');
                    }
                }

                this.$nextTick( () => {
                    showHideTooltips();
                    if( sessionStorage.navState != undefined){
                        this.state = !!parseInt(sessionStorage.navState);
                    } else {
                        this.state = !!$("#defaultClosedNavbar").length;
                        sessionStorage.navState = this.state ? 1 : 0;
                    }
                });

                await this.settings.preload(["config", "contact"]);
                await this.store.preloadSingle("productByType");
                await this.store.preloadSingle("productCustomCategory");

                if( this.store.productByType.managed_vps && !this.store.productByType.vps ){
                    this.store.productByType.vps = this.store.productByType.managed_vps;
                }
                var forSaleByType;
                var planOnly = false;
                if( this.store.productByType.package.length > 0 ){
                    forSaleByType = Object.keys(this.store.productByType.package);
                } else {
                    forSaleByType = Object.keys(this.store.productByType.stack_user_package_allowance);
                    planOnly = true;
                }
                if( planOnly ){
                    this.productBoxes.stack_user_package_allowance.link.href = this.productBoxes.package.link.href;
                    this.productBoxes.stack_user_package_allowance.title = this.productBoxes.package.title;
                }
                if (
                    this.settings.config.prefs &&
                        this.settings.config.prefs.splitWordpressHosting
                ) {
                    this.productBoxes.wordpress = {
                        link: {
                            href: "/order-wordpress-hosting",
                            label: translation.get("shop_order_allowance"),
                        },
                        title: translation.get("shop_order_wordpress_title"),
                        icon: 'fab fa-wordpress',
                        group: "group-wordpress",
                    }
                }
                if(
                    this.settings.config.prefs &&
                        this.settings.config.prefs.splitWordpressHosting &&
                        forSaleByType.length == 1 &&
                        forSaleByType[0] == 'wordpress'
                ){
                    if( planOnly ){
                        this.productBoxes.stack_user_package_allowance.link.href = "/order-wordpress-hosting";
                    }
                    this.productBoxes.package.link.href = "/order-wordpress-hosting";
                }
                this.productsAvailableByType = this.store.productByType;

                this.store.productCustomCategory.forEach((e, i) => {
                    e.category = `custom_category_${e.id}`
                    this.customProductCategories.push(e)
                    this.productsAvailableByType[`custom_category_${e.id}`] = true
                    this.productBoxes[`custom_category_${e.id}`] = {
                        link: {
                            href: `/pccategory?cat=${e.id}`,
                            label: e.linkText
                        },
                        title: e.label,
                        description: e.description,
                        icon: e.icon
                    }
                })
                const category_order = this.settings.config.categoryOrder;

                if (category_order) {
                    this.productBoxes = Object.keys(this.productBoxes).sort((a, b) => {
                        //  Check if string includes custom_category_ if so remove it when checking for index
                        const indexA = category_order.indexOf(a.replace('custom_category_', ''));
                        const indexB = category_order.indexOf(b.replace('custom_category_', ''));

                        if (indexA < indexB) return -1;
                        if (indexA > indexB) return 1;
                        return 0;
                    }).reduce(
                        (obj, key) => {
                            obj[key] = this.productBoxes[key];
                            return obj;
                        },
                        {}
                    );
                }
            },
            methods: {
                toggle() {
                    this.state = !this.state;
                    sessionStorage.navState = this.state ? 1 : 0;
                },
                logout() {
                    if(window.sessionStorage) {
                        sessionStorage.clear()
                    }
                    location.href = "/logout?r=" + (window.logoutUrl ? window.logoutUrl : (location.host === 'stackcp.com' ? "/login" : "/basket-summary-login"));
                },
                async getBrandLogo() {
                    await this.store.preloadSingle("brandLogoDataUrl");
                },
                isHiddenDefaultCategory(categoryGroup) {
                    const hiddenDefaultCategories = this.catalogue?.config?.hiddenDefaultCategories ?? [];
                    return hiddenDefaultCategories.includes(categoryGroup);
                },
                iconFor(cat) {
                    if (!cat.icon) {
                        return `<i class="far fa-shopping-cart fa-fw me-2"></i>`
                    }

                    return `<i class="${cat.icon} fa-fw me-2"></i>`
                },
                productCountCheck(type) {
                    if (type.includes('custom_category')) return true
                    switch(type) {
                    case 'custom_limit_addon':
                    case 'package':
                        if (this.productsAvailableByType['package'].constructor === Array) {
                            if (this.productsAvailableByType['package'].length === 0) {
                                return false
                            }
                        }

                        for(const p in this.productsAvailableByType[type]){
                            if( this.productsAvailableByType[type][p] ){
                                return true;
                            }
                        }
                        break;
                    case 'stack_user_package_allowance':
                        if (this.productsAvailableByType['stack_user_package_allowance'].constructor === Array) {
                            if (this.productsAvailableByType['stack_user_package_allowance'].length === 0) {
                                return false
                            }
                        }
                        return true;
                        break;
                    case 'wordpress':
                        if (
                            !this.productsAvailableByType['stack_user_package_allowance'] ||
                                !this.productsAvailableByType['stack_user_package_allowance']['wordpress']
                        ) {
                            return false
                        }
                    default:
                        return true;
                    }
                    return false;
                },
                isVisible(type) {
                    if (type.includes('custom_category')) {
                        return this.customProductCategories.find(c => c.category == type).visible;
                    }

                    return true;
                },
                productAvailabiltyCheck(type) {
                    if( type == "cloud-server" ){
                        type = "cloud_server";
                    }
                    if (
                        this.productsAvailableByType &&
                            this.productsAvailableByType[type] &&
                            this.productCountCheck(type) &&
                            this.isVisible(type)
                    ) {
                        return true;
                    }

                    if (type === 'wordpress') {
                        if (
                            this.productsAvailableByType?.stack_user_package_allowance?.wordpress &&
                                this.productCountCheck(type) &&
                                this.isVisible(type)
                        ) {
                            return true
                        }
                    }

                    return false
                }
            },
            computed: {
                currentPath(){
                    return window.location.pathname;
                },
                avatarURL() {
                    return this.settings.avatarURL;
                },
                userInitials() {
                    const person_name = this.contact.person_name
                    if(personname) {
                        const parts = person_name.split(/ /)
                        return parts[0].substring(0, 1) + parts[1].substring(0, 1)
                    } else {
                        return null
                    }
                },
                basketItemCount() {
                    return(
                        this.basket.itemsFlat && this.basket.itemsFlat.length
                    )
                },
            },

        });
        this.view = app.mount('#vue-sidebar');
    }
}

var sidebar = new VueSidebar();
sidebar.init();
if (document.querySelector('#sidenav-cdn') || document.querySelector('#sidenav-email') || document.querySelector('#sidenav-laravel') || document.querySelector('#sidenav-security-sidebar') || document.querySelector('#sidenav-domain-names') || document.querySelector('#sidenav-webtools')){
    $('.sidebar-container ul li a').tooltip().tooltip('enable');
    $('.sidebar-container ul li').tooltip().tooltip('enable');
    document.querySelector('.sidebar-container').classList.add('collapsed');
} else {
    $('.sidebar-container ul li a').tooltip().tooltip('disable');
    $('.sidebar-container ul div').tooltip().tooltip('disable');
}
